<p-card>
    <div class="container">
        <div class="sem-permissao">
            <i class="pi pi-exclamation-triangle pi-fw" style="font-size: 2rem"></i>
            <h4>Acesso não autorizado</h4>
            <p>Você não possui permissão para acessar o recurso: <strong>"{{recurso}}"</strong></p>
        </div>
    </div>
</p-card>
